
///// <reference path="../../../AH.ModelBuilder.WebClient/Scripts/typings/jquery.fancytree/jquery.fancytree.d.ts" />
//import { createTree, version } from 'jquery.fancytree'
//import 'jquery.fancytree/dist/modules/jquery.fancytree.edit';

//import "jquery";
//import "jquery-ui";
//import 'jquery.fancytree/dist/jquery.fancytree-all.min.js'

//const $ = require('jquery');

//const Fancytree = require('jquery.fancytree');
//require('jquery.fancytree/dist/jquery.fancytree-all');
////require('jquery.fancytree/dist/modules/jquery.fancytree.filter');

//import * as $ from "jquery";
//import "jquery-ui/build/.fancytree";
//import "jquery-ui";
//import "jquery.fancytree/dist/jquery.fancytree";
import "jquery.fancytree";
import 'jquery.fancytree/dist/modules/jquery.fancytree.filter';

import { NodeObject, INodeObject }from "./common/ah.mb.common.node-object";
import { IModelObserver } from "./model-notifier/ah.mb.ui.model-observer";
import { IModelActionsHandler } from "./model-notifier/ah.mb.common.model-actions-handler";
import { LinkProperty } from "./ah.mb.model-utils";
import { ModelUtils } from "./ah.mb.ui.model-utils";


//import * as Fancytree from "jquery.fancytree";

/**
     * Node information 
     */

    /**
     * Selection changed event
     */
    interface ISelectionChangedEvent {
        (nodes: NodeObject[]): void
    }

    /**
 * Nodes deleted event type
 */

    interface INodeIconClickedEvent {
        (node: NodeObject): boolean;
    }


    /**
     * Model tree class
     */
    export class ModelTree implements IModelObserver {

        tree: Fancytree.Fancytree;
        url: string;
        modelId: string;
        getNodesUrlFunc: (modelId: string, nodePathAndName: string) => string;
        modelUtils: ModelUtils;

        // Event handlers
        selectionChangedHandler: ISelectionChangedEvent;

        nodeActionsHandler: IModelActionsHandler;
        nodeIconClickedHandler: INodeIconClickedEvent;
        nodeIconDeactivatedHandler: INodeIconClickedEvent;

        private readonly modelActionsHandler: IModelActionsHandler;

        private lastNodeClicked: Fancytree.NodeData;
        private lastNodeClickCount = 0;

        /**
         * Ctor
         * @param modelServices 
         * @param variableTreeBuilderFunc 
         * @returns {} 
         */
        constructor(targetDiv: any,
            getNodesUrlFunc: (modelId: string, nodePathAndName: string) => string,
            modelId: string,
            rootTreeNode: any,
            selectionChangedHandler: ISelectionChangedEvent,
            modelActionsHandler: IModelActionsHandler,
            nodeIconClickedHandler: INodeIconClickedEvent,
            modelUtils: ModelUtils,
            nodeIconDeactivatedHandler?: INodeIconClickedEvent
        ) {


            this.getNodesUrlFunc = getNodesUrlFunc;
            this.modelId = modelId;
            this.selectionChangedHandler = selectionChangedHandler;
            this.modelActionsHandler = modelActionsHandler;
            this.nodeIconClickedHandler = nodeIconClickedHandler;
            this.modelUtils = modelUtils;
            this.nodeIconDeactivatedHandler = nodeIconDeactivatedHandler;

            // Create an initial node that is lazy
            const source = [rootTreeNode];

            const clickMode = 3; //' Fancytree.FancytreeClickFolderMode =
            //Fancytree.FancytreeClickFolderMode.activate_and_expand;

            const selectMode = 2; // Multi

            const filterOptions = {
                autoApply: true, // Re-apply last filter if lazy data is loaded
                counter: false, // Show a badge with number of matching child nodes near parent icons
                hideExpandedCounter: true, // Hide counter badge, when parent is expanded
                mode: "hide" // "dimm": Grayout unmatched nodes, "hide": remove unmatched nodes,
            };


            // Tree options
            const options:
                Fancytree.FancytreeOptions
                //
                = {
                    //keyPathSeparator: '\\', Note: this messes up LoadKeyPath if it is set
                    extensions: ["filter"],
//                    quicksearch: true,
                    source: source,
                    lazyLoad: this.lazyLoad,
                    activate: this.nodeActivated,
                    deactivate: this.nodeDeactivated,
                    clickFolderMode: clickMode,
                    selectMode: selectMode,
                click: this.nodeClicked,
                beforeExpand: (ev, data) => {

                    // Prevent annoying collapse when selecting a different folder
                    if (this.lastNodeClickCount === 0 &&
                        data.node.isExpanded())
                        return false;
                    else
                        return true;

                },
                keydown: this.keyDownHandler,
                select: this.nodeSelected,


            };

            // Doesn't seem to be in .d.ts: 
            (options as any).filter = filterOptions;
                (options as any).escapeTitles = true;


            // Create the tree
            targetDiv.fancytree(options); // treetree: Fancytree.Fancytree, 

            this.tree = targetDiv.fancytree("getTree");

        }

        expandRootNode(): Promise<any> {
            var roootNode = this.tree.getRootNode().children[0];
            return roootNode.setActive()
                .then(() => roootNode.setExpanded(true, { noEvents: true }));
            //.done(() => {
            //    // Fire callback, if specified
            //    //if (loaded)
            //    //    loaded.resolve();

            //}));

        }

        reload(modelId: string, rootTreeNode: any): Promise<any> {

            this.modelId = modelId;
            return this.tree.reload([rootTreeNode]);

        }

        /**
         * Gets a node path
         * @returns {} 
         */
        private getNodePathAndName(node: Fancytree.FancytreeNode): string {
            return this.buildNodePath(node, true);
        }

        /**
         * Gets a node path (not including the name)
         * @param node
         */
        private getNodePath(node: Fancytree.FancytreeNode): string {
            return this.buildNodePath(node, false);
        }

        /**
         * Builds a node pathj
         * @param node
         * @param includeSelf
         */
        private buildNodePath(node: Fancytree.FancytreeNode, includeSelf: boolean): string {
            var path = new Array<string>();
            if (includeSelf)
                return node.key;

            node.visitParents(node => {
                    if (node.parent) {
                        path.unshift(node.title);
                    }
                },
                includeSelf);

            const sep = "\\"; //node.tree.options.keyPathSeparator;
            return sep + path.join(sep);
        }

        /**
         * Lazy load event handler
         */
        private lazyLoad = (event: JQueryEventObject, data: Fancytree.EventData) => {
            var node = data.node;
            var nodePath = this.getNodePathAndName(node);
            var url = this.getNodesUrlFunc(this.modelId, nodePath);
            data.result = {
                global: false, // Prevent global events for this
                url: url
            }
        }


        /**
         * Node activated handler
         */
        private nodeActivated = (event: JQueryEventObject, data: Fancytree.EventData) =>
            this.fireSelectionChanged(data);


        fireSelectionChanged = (data: Fancytree.EventData) => {
            var selobj = this.getNodeObject(data.node);

            var selection = new Array<NodeObject>();
            selection.push(selobj);

            this.selectionChangedHandler(selection);

        }

        private nodeSelected = (event: JQueryEventObject, data: Fancytree.EventData) => 
            this.fireSelectionChanged(data);


        /**
         * Node deactivated handler
         */
        private nodeDeactivated = (event: JQueryEventObject, data: any) => {
            if (this.nodeIconDeactivatedHandler)
                this.nodeIconDeactivatedHandler(this.getNodeObject(data.node));
        }

        /**
         * Node clicked event
         */
        private nodeClicked = (event: JQueryEventObject, data: Fancytree.EventData) => {

            if (this.lastNodeClicked === data.node)
                this.lastNodeClickCount++;
            else
                this.lastNodeClickCount = 0;

            this.lastNodeClicked = data.node;

            // If ctrl-click, this is a selection
            if (event.ctrlKey) {
                data.node.toggleSelected();
                return false;
            }

            // If ctrl-click, also a selection
            // Select from active node to the clicked node
            if (event.shiftKey || event.ctrlKey) {
                const activeNode = data.tree.getActiveNode();
                const activeIndex = data.node.parent.children.indexOf(activeNode);
                const clickedIndex = data.node.parent.children.indexOf(data.node);

                for (let i = Math.min(activeIndex, clickedIndex); i <= Math.max(activeIndex, clickedIndex); i++)
                    data.node.parent.children[i].setSelected(true);

                return false;
            }


            var continueProcessing: boolean;
            // If clicking on the icon, show the node editor 
            if (data.targetType === "icon") {
                continueProcessing = this.nodeIconClickedHandler(this.getNodeObject(data.node));
            } else
                continueProcessing = true;



            if (continueProcessing) {


                data.tree
                    .visit(theNode => {
                        theNode.setSelected(false);
                    });

                return true;
            } else
            // Handled: prevent OnActivate
                return false;
        }

        /**
         * Gets a node object from a tree object
         * @param treeNode
         */
        private getNodeObject(treeNode: Fancytree.FancytreeNode): NodeObject {
            const nodePath = this.getNodePathAndName(treeNode);
            const obj = new NodeObject(nodePath, treeNode.data["nodeType"], treeNode.isFolder(), treeNode.data["fqmId"]);
            return obj;
        }

        /**
         * Gets the active node
         */
        getActiveNode = (): NodeObject => {
            var node = this.tree.getActiveNode();
            if (node === null)
                return null;

            return this.getNodeObject(node);
        }

        /**
         * Gets selected nodes
         * @param recurse Not yet implemented
         */
        getSelectedNodes = (recurse?: boolean): Array<NodeObject> => {

            var nodes = this.tree.getSelectedNodes();
            var result = nodes.map<NodeObject>(node => { return this.getNodeObject(node); });

            // If not multi selected, need to specify the single node selected
            if (result.length === 0) {
                const selected = this.getActiveNode();
                if (selected)
                    result.push(selected);
            }

            return result;
        }

        /**
         * IModelObserver.linkCreated
         * @param sourceNode
         * @param destNode
         * @param commodity
         * @param units
         * @param properties
         */
        linkCreated = (sourceNode: string,
            destNode: string,
            commodity: string,
            units: string,
            properties: LinkProperty[]): void => {
            // Nothing needed here
        }

        /**
 * Link deleted notification
 * @param sourceNode
 * @param destNode
 */
        linkDeleted = (sourceNode: string, destNode: string) => {
            // Nothing needed here
        }

        /**
         * Link edited notification
         * @param srcNode
         * @param destNode
         * @param commodity
         * @param units
         * @param properties
         */
        linkEdited = (srcNode: string,
            destNode: string,
            commodity: string,
            units: string,
            properties: LinkProperty[]) => {
            // Nothing needed here

        }

        /**
         * IModelObserver.NodeCreated
         * @param sender
         * @param node
         */
        nodeCreated(sender: Object, node: NodeObject, initData: any) {

            // It may have been created under a folder, but the active node
            // may be a leaf (convenience feature )

            // Or, no node may be selected
            const activeNode = this.tree.getActiveNode();

            var showCreatedNode = (parentPath: string) => {

                var theParent = this.tree.getNodeByKey(parentPath);

                if (theParent) {
                    // Refresh it's children
                    theParent.resetLazy();

                    // Show the node again
                    theParent
                        .setExpanded(true)
                        .done(
                            () => {
                                var newNode = this.tree.getNodeByKey(node.pathAndName);
                                if (newNode)
                                    newNode.setActive(true);
                            });
                }
            };


            if (activeNode) {
                const nodeToSelect =
                    activeNode.isFolder()
                        ? activeNode.key
                        : this.tree.getActiveNode().parent.key;
                showCreatedNode(nodeToSelect);
            }

            if (!activeNode) {
                // No node selected, maybe because active one was deleted.
                // Try and select the parent of the creation,
                // then select it
                const nodeToSelect = node.isFolder
                    ? node.pathAndName
                    : NodeObject.extractPath(node.pathAndName);
                this.activateNode(nodeToSelect, false)
                    .then(() => showCreatedNode(nodeToSelect));
            }
        }

        /**
         * IModelObserver.NodeRenamed
         * @param sender
         * @param pathAndName
         * @param newName
         */
        nodeRenamed(sender: Object, pathAndName: string, newName: string) {

            var treeNodeToRename: Fancytree.FancytreeNode = null;
            this.tree.visit(curNode => {
                // See if it is under the selected node's parent
                //                activeNode.parent.visit(curNode => {
                if (curNode.key === pathAndName)
                    treeNodeToRename = curNode;
            });

            interface IFqmId {
                fqmId: string;
            }

            function isFqmId(object: any): object is IFqmId {
                return 'fqmId' in object;
            }

            if (treeNodeToRename) {
                // Set name
                var oldTitle = treeNodeToRename.title;
                treeNodeToRename.setTitle(newName);

                // Update key
                var oldKey = treeNodeToRename.key;
                treeNodeToRename.key = NodeObject.extractPath(treeNodeToRename.key) + "\\" + newName;

                // Need to update child keys, if it is a parent
                treeNodeToRename.visit((curNode => {
                        curNode.key = curNode.key.replace(oldKey, treeNodeToRename.key);
                    // Also need to update its fqmId
                    if (isFqmId(curNode.data))
                        curNode.data.fqmId = curNode.data.fqmId.replace(oldTitle, newName);
                    })
                );

                // Also need to update its fqmId
                if (isFqmId(treeNodeToRename.data))
                    treeNodeToRename.data.fqmId = treeNodeToRename.data.fqmId.replace(oldTitle, newName);

                // Force a refresh of the node, if it is selected
                if (treeNodeToRename && treeNodeToRename === this.tree.getActiveNode())
                    this.selectionChangedHandler([this.getNodeObject(treeNodeToRename)]);


            }
        }

        /**
         * Scrolls to top of free
         */
        scrollToTop() {
            this.tree.getRootNode().children[0]
                //getNodeByKey('\\Reports')
                .makeVisible();
        }


        pruneNodes = (nodes: string[]): Promise<any> => {

            var result = Promise.resolve(); 

            var activeNode = this.tree.getActiveNode();
            var activeNodePath = activeNode ? activeNode.key : null;

            // Prune the tree
            nodes.forEach(node => {

                var treeNode = this.tree.getNodeByKey(node);

                // There can be multiple of these if it is pinned
                while (treeNode)  {
                    if (treeNode)
                        treeNode.remove();
                    treeNode = this.tree.getNodeByKey(node);

                }
            });

            // If a leaf was activated and deleted by diagram, we might have no selection
            // which is not good because keyboard events won't work
            // so select the parent
            if (this.tree.getActiveNode() == null && activeNodePath) {

                var nodeToFocus = this.tree.getNodeByKey(activeNodePath);
                if (!nodeToFocus) {
                    const parentPath = NodeObject.extractPath(activeNodePath);
                    nodeToFocus = this.tree.getNodeByKey(parentPath);
                }

                if (nodeToFocus)
                    result = nodeToFocus.setActive(true, { noEvents: true }).done(() =>
                        nodeToFocus.setExpanded());
            }

            return result;
        }

        /**
         * IModelObserver.nodesDeleted
         * @param sender
         * @param nodes
         */
        nodesDeleted = (sender: Object, nodes: Array<NodeObject>): Promise<any> => {
            var nodePathsAndNames = nodes.map(node => node.pathAndName);
            return this.pruneNodes(nodePathsAndNames);


        }

        /**
         * Nodes pasted handler
         * @param sender
         * @param nodePathAndNames
         */
        nodesPasted = (sender: Object,
            targetPath: string,
            nodePathAndNames: Array<string>,
            isCut: boolean) => {

            // If cutting, we need to prune the cut
            if (isCut) {
                nodePathAndNames.forEach(node => {

                    var treeNode = this.tree.getNodeByKey(node);
                    if (treeNode)
                        treeNode.remove();
                });
            }

            // Refresh target path, regardless of cut or paste
            this.refreshNodeChildren(targetPath);
        }

        /**
         * Refreshes node children
         */
        refreshNodeChildren = (nodePathAndName: string): Promise<any> => {
            var node = this.tree.getNodeByKey(nodePathAndName);
            if (node) {
                node.resetLazy();

                // Get the node again in case it's gone
                // const unlazyNode = this.tree.getNodeByKey(nodePathAndName);

                //   if (unlazyNode)
                // Show the node again, in case it was collapsed by resetLazy above
                // Do not fire the event which will case the diagram to be re-created
                return node.setExpanded(); // unlazyNode.setActive(true, {noEvents: true}).done(() =>
                //unlazyNode.setExpanded());
            }
            return Promise.resolve();
        }

        /**
         * Applies a filter
         * @param text
         */
        applyFilter(text: string) {

            // Pass a string to perform case insensitive matching
            if (!text)
                this.tree.clearFilter();
            else {
                //const opts = {
                //    autoExpand: true
                //};


                this.tree.filterNodes(text);

                (this.tree as any).expandAll();
//                    node => node.key.indexOf(text) > -1);
                //const untypedTree: any = this.tree;
                ////this._tree
                //untypedTree
                //    .filterNodes(text, opts);
                //function (node) {
                //    return node.key.indexOf(text) > -1;
                //}, opts)

            }
        }

        /**
 * Keydown handler
 * @param event
 * @param data
 */
        private keyDownHandler = (event: JQueryEventObject, data: Fancytree.EventData): boolean => {
            switch (event.which) {
            case 113: // [F2]

                const node = this.getNodeObject(data.node);

                // Call handler to rename the node
                // The handler will actually prompt for the node name, so we pass in
                // an empty string
                this.modelActionsHandler.renameNode(node.pathAndName);

                // Response will come in IModelObserver.nodeRenamed

                return false;

            case 46: // Delete
                /*if (!this._tree.isEditing())*/
                    {
                        this.deleteClick({ bypassRecycleBin: event.shiftKey });
                    // Todo internalDeleteSector(node.tree);
                    return false;
                }

            case 65: // Ctrl-A for select all at level:
                if (event.ctrlKey) {
                    // Todo selectAll(node);
                    return false;
                }

            case 67: // Ctrl-C for copy
                if (event.ctrlKey) {
                    this.internalCopySelectedNodes(data.tree, false);
                    return false;
                }

            // case 86: // Ctrl-V for paste
            // This doesn't work here, clipboard data is only accessible from document.paste event

            case 88: // Ctrl-X for cut
                if (event.ctrlKey) {
                    this.internalCopySelectedNodes(data.tree, true);
                    return false;
                }
            }

            return true;
        }

        /**
         * Delete is done somewhere else, which trigger event handler
         */
        private deleteClick(options: { bypassRecycleBin: boolean }) {
            this.modelActionsHandler.deleteNodes(this.getSelectedNodes(), options);
        }


        /**
         * Copies or cuts selected nodes
         * @param isCut
         */
        copySelectedTreeNodes(isCut: boolean): Number {
            return this.internalCopySelectedNodes(this.tree, isCut);
        }

        /**
         * Copies or cuts selected nodes
         * @param tree
         * @param isCut
         */
        private internalCopySelectedNodes(tree: Fancytree.Fancytree, isCut: boolean): Number {

            const selection = tree.getSelectedNodes(true);
            const activeNode = tree.getActiveNode();

            // Figure out if we need to add the active node to the selection
            if (selection.indexOf(activeNode) === -1) {
                var selectingLeafs = false;

                selection.some(node => {
                    if (!node.isFolder()) {
                        selectingLeafs = true;
                        return true;
                    }

                    return false;
                });

                // Note: active node is not included in selection
                // Only if we are not selecting leafs, add the sector
                if (selection.length === 0 || (selectingLeafs !== activeNode.isFolder()))
                    selection.splice(0, 0, tree.getActiveNode());
            }

            // Get full pths of each node
            var nodeFullPaths = [];
            selection.forEach(node => {
                var fullPath = node.key;
                nodeFullPaths.push(fullPath);
            });

            // Show notification
            const copyCount = selection.length;
            if (copyCount === 0) {
            }
            //_userNotifier.showNotification("No nodes selected", false, false);
            else {
                // copy the selection to the clipboard, as a Json object
                // Including the modelId, in case we copy to a different model

                this.modelActionsHandler.copyNodesToClipboard(isCut, nodeFullPaths);

            }

            return copyCount;
        }


        /**
         * Sets child nodes of a nodes (used when fully loading tree)
         */
        setChildNodes = (nodePathAndName: string, nodes: any) => {
            var treeNode = this.tree.getNodeByKey(nodePathAndName);
            treeNode.removeChildren();
            treeNode.addChildren(nodes);
        }

        /**
         * Tries to find a node
         */
        findNode = (nodePathAndName: string): NodeObject => {
            var treeNode = this.tree.getNodeByKey(nodePathAndName);
            return treeNode == null ? null : this.getNodeObject(treeNode);
        }

        findNodeByName(name: string): Promise<NodeObject> {
            var match: Fancytree.FancytreeNode = null;
            this.tree.visit((node => {
                if (node.title === name) {
                    match = node;
                    return false;
                }
                return true;

            }));
            if (match)
                return Promise.resolve(this.getNodeObject(match)); 
            return Promise.reject();
    
            };


        /**
         * Activate node
         */
        activateNode = (nodePathAndName: string, gotoParent: boolean): Promise<any> => {

            var treeNode = this.tree.getNodeByKey(nodePathAndName);
            // Assume node exists

            if (gotoParent) {
                treeNode = treeNode.parent;
            }

            if (treeNode !== this.tree.getActiveNode())
                return treeNode.setActive()
                    .done(() => treeNode.setExpanded())
                    .done(() => treeNode.makeVisible());


            return Promise.resolve();
        }

        /**
         * Expands a node
         * @param nodePathAndName
         * @param expanded
         */
        expandNode(nodePathAndName: string, expanded: boolean) {
            var initialNode = this.tree.getNodeByKey(nodePathAndName);
            if (initialNode)
                initialNode.setExpanded(expanded, { noEvents: true });
        }

        /**
         * Expands a node recursively
         * @param nodePathAndName 
         * @returns {} 
         */
        expandToNode = (nodePathAndName: string): Promise<any> => {
            var initialNode = this.tree.getNodeByKey(nodePathAndName);
            if (initialNode)
                return Promise.resolve();

            // Have to make path in the form /{nodekey}/{nodekey2} etc
            // So for example /\Root/\World/\Gas

            var allPaths = new Array<string>();

            var uglyShit = "";

            var split = ModelUtils.extractPathStackFromPathAndName(nodePathAndName, true);

            //var joined = split.join("/\\");

            //uglyShit = `/\\` + joined;

            //var withSlashes = split.map(p => "/\\" + p);

            for (let i = 0; i < split.length; i++) {
                const segments = split.slice(0, i + 1);
                const joined = `\\${segments.join("\\")}`;
                allPaths.push(`${joined}`);
                uglyShit = uglyShit + "/" + joined;
            }
            return this.tree.loadKeyPath(
                uglyShit,
                () => { });

        }

        nodesGrouped(sender, nodes: INodeObject[], groupName: string) {

            if (nodes) {
                const sector = nodes[0].path;
                this.refreshNodeChildren(sector);
            }
        }

        nodesUngrouped(sender, groupNodePathAndName: string): Promise<any> {

           return this.pruneNodes([groupNodePathAndName])
                .then(() => {
                    const sector = NodeObject.extractPath(groupNodePathAndName);
                   return this.refreshNodeChildren(sector);

                });

            //var goneNodes  = new Array<NodeObject>();

            //var sectorObj  = new NodeObject(groupNodePathAndName, "", false,


            //this.nodesDeleted(this, )

            //var activeNode = this.getActiveNode();
            //if (activeNode && activeNode.pathAndName === sector)
            //    this.nodesDeleted()

        }

    }










// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.model-tree.ts